/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetMember,
  FleetMemberCreateInput,
  FleetMembersList,
  FleetMembersParams,
  SchemaValidationErrorResponse,
  StandardError,
  StandardMessage,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Member
 */
export const createFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetMemberCreateInput: MaybeRefOrGetter<FleetMemberCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetMemberCreateInput = toValue(fleetMemberCreateInput);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetMemberCreateInput, signal
    },
      );
    }




export const getCreateFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetMember>>, TError,{fleetSlug: string;data: FleetMemberCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetMember>>, TError,{fleetSlug: string;data: FleetMemberCreateInput}, TContext> => {

const mutationKey = ['createFleetMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetMember>>, {fleetSlug: string;data: FleetMemberCreateInput}> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetMember(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetMember>>>
    export type CreateFleetMemberMutationBody = FleetMemberCreateInput
    export type CreateFleetMemberMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create Member
 */
export const useCreateFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetMember>>, TError,{fleetSlug: string;data: FleetMemberCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetMember>>,
        TError,
        {fleetSlug: string;data: FleetMemberCreateInput},
        TContext
      > => {
      return useMutation(getCreateFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Member List
 */
export const fleetMembers = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetMembersList>(
      {url: `/fleets/${fleetSlug}/members`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetMembersQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>,) => {
    return [
    'fleets',fleetSlug,'members', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetMembersQueryOptions = <TData = Awaited<ReturnType<typeof fleetMembers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMembersQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMembers>>> = ({ signal }) => fleetMembers(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>
}

export type FleetMembersQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMembers>>>
export type FleetMembersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Member List
 */

export function useFleetMembers<TData = Awaited<ReturnType<typeof fleetMembers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMembersQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Remove Fleet Member
 */
export const destroyFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/members/${username}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetMemberMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMember>>, TError,{fleetSlug: string;username: string}, TContext> => {

const mutationKey = ['destroyFleetMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetMember>>, {fleetSlug: string;username: string}> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  destroyFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetMember>>>

    export type DestroyFleetMemberMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Remove Fleet Member
 */
export const useDestroyFleetMember = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetMember>>,
        TError,
        {fleetSlug: string;username: string},
        TContext
      > => {
      return useMutation(getDestroyFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Accept Member
 */
export const acceptFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<StandardMessage>(
      {url: `/fleets/${fleetSlug}/members/${username}/accept`, method: 'PUT', signal
    },
      );
    }




export const getAcceptFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMember>>, TError,{fleetSlug: string;username: string}, TContext> => {

const mutationKey = ['acceptFleetMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptFleetMember>>, {fleetSlug: string;username: string}> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  acceptFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof acceptFleetMember>>>

    export type AcceptFleetMemberMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Accept Member
 */
export const useAcceptFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptFleetMember>>,
        TError,
        {fleetSlug: string;username: string},
        TContext
      > => {
      return useMutation(getAcceptFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * No Member found
 * @summary Decline Member
 */
export const declineFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<StandardMessage>(
      {url: `/fleets/${fleetSlug}/members/${username}/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineFleetMember>>, TError,{fleetSlug: string;username: string}, TContext> => {

const mutationKey = ['declineFleetMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineFleetMember>>, {fleetSlug: string;username: string}> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  declineFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof declineFleetMember>>>

    export type DeclineFleetMemberMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Decline Member
 */
export const useDeclineFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineFleetMember>>,
        TError,
        {fleetSlug: string;username: string},
        TContext
      > => {
      return useMutation(getDeclineFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * No Member found
 * @summary Demote Member
 */
export const demoteFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/members/${username}/demote`, method: 'PUT', signal
    },
      );
    }




export const getDemoteFleetMemberMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof demoteFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof demoteFleetMember>>, TError,{fleetSlug: string;username: string}, TContext> => {

const mutationKey = ['demoteFleetMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof demoteFleetMember>>, {fleetSlug: string;username: string}> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  demoteFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DemoteFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof demoteFleetMember>>>

    export type DemoteFleetMemberMutationError = ErrorType<StandardError>

    /**
 * @summary Demote Member
 */
export const useDemoteFleetMember = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof demoteFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof demoteFleetMember>>,
        TError,
        {fleetSlug: string;username: string},
        TContext
      > => {
      return useMutation(getDemoteFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * No Member found
 * @summary Promote Member
 */
export const promoteFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/members/${username}/promote`, method: 'PUT', signal
    },
      );
    }




export const getPromoteFleetMemberMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof promoteFleetMember>>, TError,{fleetSlug: string;username: string}, TContext> => {

const mutationKey = ['promoteFleetMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteFleetMember>>, {fleetSlug: string;username: string}> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  promoteFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PromoteFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof promoteFleetMember>>>

    export type PromoteFleetMemberMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Promote Member
 */
export const usePromoteFleetMember = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteFleetMember>>, TError,{fleetSlug: string;username: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof promoteFleetMember>>,
        TError,
        {fleetSlug: string;username: string},
        TContext
      > => {
      return useMutation(getPromoteFleetMemberMutationOptions(options), queryClient);
    }
